/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Picker_Placeholder_LeadInputs */

const cs_entity_picker_placeholder_lead = /** @type {(inputs: Entity_Picker_Placeholder_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hledat lead (jméno, e-mail, telefon)`)
};

const en_entity_picker_placeholder_lead = /** @type {(inputs: Entity_Picker_Placeholder_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search lead (name, email, phone)`)
};

/**
* | output |
* | --- |
* | "Search lead (name, email, phone)" |
*
* @param {Entity_Picker_Placeholder_LeadInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const entity_picker_placeholder_lead = /** @type {((inputs?: Entity_Picker_Placeholder_LeadInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Picker_Placeholder_LeadInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_picker_placeholder_lead(inputs)
	return cs_entity_picker_placeholder_lead(inputs)
});